import { action, computed } from 'mobx';
import type * as THREE from 'three';
import { Entity } from '@/engine/core/entity';
import type { IValue } from '@/engine/DataFlow/Graph';
import { Type } from '@/engine/DataFlow/Type';
import type { IIndicationModel } from '../interfaces';

export interface AnnotationProps {
  point?: THREE.Vector3;
  labelPoint?: THREE.Vector3;
  text?: string;
}

export class AnnotationModel extends Entity<AnnotationProps> implements IIndicationModel, IValue {
  public static readonly Type: Type = new Type('AnnotationModel');

  public readonly type: Type = AnnotationModel.Type;

  public getPoints(): Array<THREE.Vector3 | undefined> {
    return [this.props.point];
  }

  public getPointByIndex(): THREE.Vector3 | undefined {
    return this.props.point;
  }

  @action
  public setText(text: string): void {
    this.props.text = text;
  }

  @action
  public setPoint(point: THREE.Vector3): void {
    this.props.point = point;
  }

  @action
  public setLabelPoint(point: THREE.Vector3): void {
    this.props.labelPoint = point;
  }

  @action
  public setPointByIndex(_: number, point: THREE.Vector3): boolean {
    this.props.point = point;
    return true;
  }

  @computed
  public get point(): THREE.Vector3 | undefined {
    return this.props.point;
  }

  @computed
  public get labelPoint(): THREE.Vector3 | undefined {
    return this.props.labelPoint;
  }

  public get text(): string | undefined {
    return this.props.text;
  }
}
